import { Link } from "react-router-dom";

// Elegant text wordmark matching Vista Banquet Hall brand identity.
export default function Logo({ light = false, className = "", testId = "logo" }) {
  const mark = light ? "text-ivory" : "text-navy";
  const sub = light ? "text-ivory/70" : "text-navy/60";
  return (
    <Link to="/" data-testid={testId} className={`group flex items-center gap-3 ${className}`}>
      {/* geometric gold + navy mark */}
      <span className="relative inline-flex h-9 w-9 items-center justify-center">
        <svg viewBox="0 0 40 40" className="h-9 w-9" fill="none">
          <path d="M6 6 L20 24 L20 8 L34 6 L20 34 Z" fill="#C6A04D" />
          <path d="M6 6 L20 24 L20 8 Z" fill={light ? "#FAF9F6" : "#0B132B"} />
        </svg>
      </span>
      <span className="flex flex-col leading-none">
        <span className={`font-sans text-[1.15rem] font-semibold tracking-[0.35em] ${mark}`}>
          VISTA
        </span>
        <span className={`font-sans text-[0.55rem] font-medium tracking-[0.42em] ${sub}`}>
          BANQUET&nbsp;HALL
        </span>
      </span>
    </Link>
  );
}
